import FragmentPage from '../core/FragmentPage';

export default class TablonPage extends FragmentPage {
  constructor(meta) {
    super('tablon', meta);
  }
}
